
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHdg as ObiHdgElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hdg.js';
 
 
 

 
 export const ObiHdg = createComponent({
   react: React,
   tagName: 'obi-hdg',
   elementClass: ObiHdgElement,
   events: {
     
   }
  });
 
 